export default __webpack_public_path__ + "static/1367-1e863955ef284908ee65a490a68654dc.gif";